export const formatApiUrl = (apiBaseUrl?: string) => {
  return apiBaseUrl ? `https://${apiBaseUrl}/api/` : undefined;
};
